function TagItem({eachTag, index}) {
  return (
    <li className="each-tag" key={index}>
      {eachTag}
    </li>
  );
}

export default TagItem;